<template>
  <header class="p-24 pb-16 bg-white px-24 w-full border-b border-neutral-10">
    <div class="flex items-center shrink-0">
      <h1 class="text-headline-1 text-neutral-100">
        {{ title }}
      </h1>

      <q-space></q-space>

      <OButtonClose class="text-neutral-70" @click="emit('click:close')" />
    </div>

    <div class="mt-16 flex items-center gap-40">
      <OFormField v-if="user?.nome">
        <p v-t="'responsible'" class="text-headline-4 text-neutral-70"></p>
        <OAvatar :nome="user?.nome"></OAvatar>
      </OFormField>

      <div>
        <p v-t="'date'" class="text-headline-4 text-neutral-70"></p>
        <p class="text-pararaphy-2 text-neutral-100">
          {{ GLOBAL.FData(data) }}
        </p>
      </div>
    </div>
  </header>
</template>

<script setup>
import GLOBAL from 'js/utils/GLOBAL'
import OAvatar from 'components/Avatar/OAvatar.vue'
import OButtonClose from 'components/Button/OButtonRounded.vue'
import OFormField from 'components/Field/OFormField.vue'

const props = defineProps({
  title: String,
  data: String,
  user: Object,
})

const emit = defineEmits(['click:close'])
</script>

<style lang="scss" scoped></style>
